import { Component, OnInit, Input, ViewChild, ViewContainerRef, TemplateRef, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { PropertyListingService } from '../shared/providers/property-listing.service';
import { IPropertyCard } from '../shared/models/propertycard';
import { IPropertySearchCriteria } from '../shared/models/propertysearchcriteria';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { PropertyListingBase } from './property-listing-base';
import { HttpClient } from '@angular/common/http';
import { PropertyListViewComponent } from './property-list-view/property-list-view.component';
import { IFilterable } from './filterable';
import { PropertyMapViewComponent } from './map-view/map-view.component';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LoaderService } from '../shared/providers/loader.service';
import { environment } from '../../environments/environment';
import { ToastService } from '../shared/providers/toast.service';
import { UserManagerService } from '../shared/providers/user-manager.service';
import { PropertyFor } from '../shared/enum/enum';
import { SharedService } from '../shared/providers/shared.service';
import { AuthService } from '../shared/auth/auth.service';
import { IPageStatusModel } from '../shared/models/PageStatusModel';
import { Location } from '@angular/common';
import { ValidationService } from '../shared/providers/validation.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { CommonService } from '../shared/providers/common.service';
import { json } from 'express';
import { ISavedSearchOutputModel } from '../shared/models/SavedSearchOutputModel';
import { PropertySearchComponent } from './property-search/property-search.component';

export enum View {
  List = 0,
  Grid = 1,
  Sort = 2,
  Map = 3,
}

export enum Sort {
  PriceLowHigh = "PLH",
  PriceHighLow = "PHL",
  TenantAtoZ = "TAZ",
  TenantZtoA = "TZA",
  //Rank = 'RNK'
  Rank = 'PHL'
}

export enum FilterSearch {
  SaveSearch = 1,
  Favorites = 2,
  Dislike = 3,
}

export enum YesNo {
  Yes = 1051,
  No = 1052
}

enum Access1031 //53
{
  NotSent1031Request = 6550,
  Sent1031Request = 6551,
  EBRAaccepted = 6552,
  Has1031Access = 6553,
  EBRALinkSent = 6554,
}


@Component({
  selector: 'property-listing',
  templateUrl: './property-listing.component.html',
  styleUrls: ['property-listing.component.css']
})

export class PropertyListingComponent extends PropertyListingBase implements OnInit, OnDestroy {
  subscription: Subscription = new Subscription();
  modalRefLogin: BsModalRef;
  currentPoint: number;
  view: View;
  _takeCount = 20;
  lastScroll = 0;
  @ViewChild(PropertyListViewComponent, { static: false }) propertyTableView: IFilterable;
  @ViewChild(PropertyMapViewComponent, { static: false }) propertyMapListView: IFilterable;
  @ViewChild(PropertySearchComponent) child: PropertySearchComponent;
  sort = Sort;
  filterSearch = FilterSearch;
  user: any;
  canShowAddProperty = false;
  isFav = false;
  isDisliked = false;
  propertyFor = PropertyFor;
  activePropertyTab = PropertyFor.Sale;
  canShow1031Properties = false;
  Is1031EnabledId = YesNo.No;
  sortOption = '(Price High to Low)';
  canShowsavedSearch = false;
  // toaster
  position = 'bottom-right';
  title: string;
  msg: string;
  showClose = true;
  timeout = 5000;
  theme = 'bootstrap';
  type = 'default';
  closeOther = false;
  // toaster
  filterStateId = null;
  isPropertySaleTabHidden: boolean = false;
  currentMenu = '';
  isCollapsed = false;
  search = '';
  IsWpLogin = false;
  IsWpLogout = false;
  @ViewChild('logOutPopUp', { static: true }) logOutPopUp: TemplateRef<any>;
  PageStatusModel = {} as IPageStatusModel;
  isRessetPassword = false;
  isPasswordResetSuccess = false;
  signEBRA = false;
  isRedirect = false;
  isUserAPICalled: boolean = false;
  isTCAccepted = true;
  public current1031view: number = 0;
  public currentListingview: number = 1;
  FilterStaus = false;
  constructor(protected http: HttpClient, protected _propertyListingService: PropertyListingService,
    vcr: ViewContainerRef, private toastyService: ToastrService,
    protected authService: AuthenticationService,
    protected activatedRoute: ActivatedRoute,
    private router: Router,
    protected loaderService: LoaderService,
    private _toastService: ToastService,
    private Shared: SharedService,
    private modalService: BsModalService,
    private commonService: CommonService,
    private _userService: UserManagerService,
    private changeRef: ChangeDetectorRef, private _auth0: AuthService, private _location: Location, private Validation: ValidationService) {
    super(_propertyListingService, http, authService, loaderService, activatedRoute);
    this.loaderService.display(true);
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.search = params['search'];
      this.isRedirect = params['redirect'];
      this.isFav = params['isFav'] != undefined ? true : false;
      this.IsWpLogin = params['wplogin'];
      this.IsWpLogout = params['wplogout'];
      this.isRessetPassword = params['email'] != null && params['email'].length > 0 ? true : false;
      this.isPasswordResetSuccess = params['success'];
      this.signEBRA = params['signEBRA'];
      if (this.isRessetPassword && this.isPasswordResetSuccess && !this._auth0.IsLoginFromResetCalled) {
        this.authService.loggedIn.next(false);
        this._auth0.IsLoginFromResetCalled = true;
        this._auth0.login();
      }

      this.isDisliked = params['isDisliked'] != undefined ? true : false;
      if (this.isFav || this.isDisliked || (this.search != null && this.search != undefined && this.search != '')) {
        this.FilterStaus = true;
      }
      if (this.isFav) {
        this.currentMenu = "Favorites";
      }
      else if (this.isDisliked) {
        this.currentMenu = "Disliked";
      }
      else if (this.search) {
        this.currentMenu = "Saved Searches";
        this.searchCriteria.IsSavedSearch = true;
        this.IsFromSaveSearch = true;
      }
      else {
        this.currentMenu = '';
      }
      this.searchCriteria.Brokerages = [];
      if (this.search != undefined) {

        this.subscription.add(this._propertyListingService.getUserSavedSearchCriteria(this.search).subscribe((response: IPropertySearchCriteria) => {
          this.searchCriteria = response;
          this.bindSavedSearch();
          this.searchCriteria.IsTileList = true;
          this.propertySearchCriteria(this.searchCriteria);
        }));
      }
      else if (this.isFav) {
        this.authService.isLoggedIn.subscribe(i => { this.isUserLoggedIn = i });
        let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
        if (loggedUserDetails != null && loggedUserDetails != undefined && loggedUserDetails != '') {
          this.user = loggedUserDetails;
        }
        this.defaultSearchCriteriaValues();
        this.searchCriteria.IsFavorite = true;
        this.searchCriteria.IsDisliked = false;
        this.isPropertySaleTabHidden = false;
        //this.activePropertyTab = 601;
        //this.searchCriteria.PropertyFor = this.activePropertyTab;

        this.activePropertyTab = this._propertyListingService.activePropertyTab === undefined || this._propertyListingService.activePropertyTab == 0 ? 601 : this._propertyListingService.activePropertyTab;

        this._propertyListingService.showDisLike = false;
        this.propertySearchCriteria(this.searchCriteria);

      }
      else if (this.isDisliked) {
        this.authService.isLoggedIn.subscribe(i => { this.isUserLoggedIn = i });
        if (this.isUserLoggedIn) {
          let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
          this.user = loggedUserDetails;
        }
        this.defaultSearchCriteriaValues();
        this.searchCriteria.IsFavorite = false;
        this.searchCriteria.IsDisliked = true;
        this.isPropertySaleTabHidden = true;
        this.activePropertyTab = 602;
        this.searchCriteria.PropertyFor = this.activePropertyTab;
        this._propertyListingService.showDisLike = true;
        this.propertySearchCriteria(this.searchCriteria);

      }
      else {

        this.searchCriteria.IsFavorite = false;
        this.searchCriteria.IsDisliked = false;
        this.searchCriteria.IsSearchButtonClicked = false;
        this._propertyListingService.showDisLike = false;
        this.currentPoint = 0;
        this.isPropertySaleTabHidden = false;
        this._propertyListingService.activePropertyTab = PropertyFor.Sale;
        if (this._propertyListingService.currentView == 3) {

          this.searchCriteria.IsMapView = true;
          this.searchCriteria.IsTileList = false;

          //this.propertyMapListView.filter(this.searchCriteria);

          if (this._propertyListingService.criteria != undefined && this._propertyListingService.criteria.TakeCount != undefined) {
            this.searchCriteria = this._propertyListingService.criteria;
          }

          this.activePropertyTab = this.searchCriteria.PropertyFor === undefined || this.searchCriteria.PropertyFor == 0 ? 601 : this.searchCriteria.PropertyFor;

          this.propertySearchCriteria(this.searchCriteria);

        }
        else {

          //if (_propertyListingService.criteria.PropertyStatus !== null && _propertyListingService.criteria.PropertyStatus !== undefined) {
          //    _propertyListingService.criteria.PropertyStatus.splice(_propertyListingService.criteria.PropertyStatus.indexOf(355), 1);
          //}

          super.ngOnInit();
        }
        this.setUserRights();
      }
      this.loaderService.display(false);
    });
  }
  bindSavedSearch() {
    if (this.searchCriteria.Address != null && this.searchCriteria.AddressType != null) {
      let address
        = {
        Address: this.searchCriteria.Address,
        AddressTypeId: this.searchCriteria.AddressTypeId,
        AddressType: this.searchCriteria.AddressType,
        AddressTypeName: this.searchCriteria.AddressTypeName
      };
      if (this.searchCriteria.AddressType == 4) {
        this.searchCriteria.TenantFullAddress = address;
      }
      else if (this.searchCriteria.AddressType == 1) {
        this.searchCriteria.TenantAddress.push(address);
      }
      if (this.searchCriteria.AddressType != 4) {
        this.searchCriteria.Address = null;
        this.searchCriteria.AddressType = null;
        this.searchCriteria.AddressTypeId = null;
        this.searchCriteria.AddressTypeName = null;
      }
    }
  }
  public decrementPropertyCount(alter: number): void {
    if (this.searchCriteria.PropertyFor == 601) {
      this.propertyTabCount = this.propertyTabCount - 1;
      if (this.propertyTabCount < 0) {
        this.propertyTabCount = 0;
      }

    }
    else {
      this.propertyCount = this.propertyCount - alter;
      if (this.propertyCount < 0) {
        this.propertyCount = 0;
      }
    }
    this.changeRef.detectChanges();
  }

  onHomeBreadCrumbClick() {
    this.router.navigateByUrl('/principal-dashboard');
  }

  public getPropertyCount(propertyListCount: any): void {

    if (this.searchCriteria.PropertyFor == 601) {
      this.propertyTabCount = propertyListCount;

    }
    else {
      this.propertyCount = propertyListCount;
    }

    this.changeRef.detectChanges();
  }

  public updatePropertyCount(propertyListCount: any): void {
    if (this.searchCriteria.PropertyFor == 601) {
      this.propertyTabCount = propertyListCount;

    }
    else {
      this.propertyCount = propertyListCount;
    }
  }

  public getPropertyPriorityChange(): void {
    this.propertySearchCriteria(this.searchCriteria);
    this.changeRef.detectChanges();
  }
  ngOnInit() {
    this.loaderService.display(true);
    this.loadContent();
    this.authService.isLoggedIn.subscribe(response => {

      this.isUserLoggedIn = response;
      if (this.IsWpLogin && !response) {
        this._auth0.IsFroWordPress = true;
        this.IsWpLogin = false;
        this._location.go('propertylisting?request=buy');
        if (this.authService.isAuth0Enabled) {
          document.getElementById("openModalButton").click();
        }
      }
      else {
        this._auth0.IsFroWordPress = false;
      }
      if (response) {
        let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
        this.user = loggedUserDetails;
        this.setUserRights();

        if (this.IsWpLogout) {
          this._location.go('propertylisting?request=buy');
          this._auth0.logoutTemplate = this.logOutPopUp;
          this._auth0.WPlogout();
        }
      }
      else if (!response && this.isRedirect && !this.IsWpLogin) {
        document.getElementById("openModalButton").click();
      }
      if (this.user != '') {
        if (this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)) {
          this.canShowsavedSearch = true;
        }
      }
      if (this.isFav || this.isDisliked) {
        this.canShowsavedSearch = false;
      }
    });
    this.checknetLeaseTabAcees();
    this.bindSavedSearch();
    this.loaderService.display(false);
  }
  ngAfterViewInit() {
    if (this.canShowsavedSearch || this.authService.Broker()) {
      this.getSavedSearches();

    }
  }
  isUserLoggedIn = false;
  loadContent() {
    this.loaderService.display(true);
    if ((this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.authService.IsUserRole(this.authService.UserRole.ExternalBroker))) {
      this.user = this.authService.user != null ? this.authService.user : "";
      this._userService.CheckIfUserAcceptedTC(this.user.Id).subscribe(response => {
        this.isTCAccepted = response as boolean;
        if (!this.isTCAccepted && !this.authService.IsTcModalCalled) {
          this._propertyListingService.logout();
        }
      });
    }

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params['tab'] == 'netleasemarketing/') {
        this.searchCriteria.PropertyFor = this.propertyFor.Exchange1031
      }
    });


    this.view = View[View[this._propertyListingService.GetCurrentView()]];
    if (this.searchCriteria.PropertyFor != this.propertyFor.Exchange1031) {
      this.currentListingview = this.view;
      localStorage.setItem("ListingTab", JSON.stringify(this.currentListingview));
      if (localStorage.getItem('1031Tab') != null) {
        this.current1031view = (JSON.parse(localStorage.getItem('1031Tab')));
      }
      else {
        this.current1031view = View.List;
        localStorage.setItem("1031Tab", JSON.stringify(this.current1031view));
      }
    }
    else {
      this.current1031view = this.view;
      localStorage.setItem("1031Tab", JSON.stringify(this.current1031view));
      if (localStorage.getItem('ListingTab') != null) {
        this.currentListingview = (JSON.parse(localStorage.getItem('ListingTab')));
      }
      else {
        this.current1031view = View.Grid;
        localStorage.setItem("ListingTab", JSON.stringify(this.currentListingview));
      }
    }
    this.setUserRights();

  }
  setUserRights() {
    this.user = this.authService.user != null ? this.authService.user : "";
    if (this._propertyListingService.criteria != undefined) {
      this.activePropertyTab = this._propertyListingService.criteria.PropertyFor != undefined ? this._propertyListingService.criteria.PropertyFor : PropertyFor.Sale;
    }
    else {
      this.activePropertyTab = (this._propertyListingService.activePropertyTab != undefined ? this._propertyListingService.activePropertyTab : PropertyFor.Sale);
    }
    this.authService.isLoggedIn.subscribe(response => {
      this.isUserLoggedIn = response;
      if (response) {
        let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
        this.user = loggedUserDetails;
      }
    });
    if (this.user != '') {
      if (this.authService.Admin() || this.authService.SuperAdmin() || this.authService.Broker()) {
        this.canShowAddProperty = true;
      }

      this.canShow1031Properties = true;
      if (this.authService.ExternalBroker() || this.authService.DataEntryStaff()) {
        this.canShow1031Properties = false;
      }
      if (this.authService.Principal() || this.authService.Principal1031()) {
        if (!this.isUserAPICalled) {
          this.isUserAPICalled = true;
          this.subscription.add(this._userService.getUserDetails(this.user.Guid).subscribe(response => {
            if (response != null) {
              this.Is1031EnabledId = response.Is1031EnabledId;
              this.accessTo1031Id = response.Access1031;
              if (this.signEBRA) {
                this.searchCriteria.PropertyFor == PropertyFor.Exchange1031;
                this.check1031InquiryStatus(PropertyFor.Exchange1031);
              }
            }
          }));
        }

        if (this.activePropertyTab == PropertyFor.Exchange1031) {
          this._propertyListingService.showDisLike = true;
        }
      }
    }
    else {
      if (this.signEBRA) {
        document.getElementById("openModalButton").click();
      }
    }
  }
  accessTo1031Id = Access1031.NotSent1031Request;
  onViewChange(view: View) {
    if (this.PageStatusModel == null) {
      this.PageStatusModel = {} as IPageStatusModel;
    }
    if (JSON.parse(localStorage.getItem("PageStatus")) != null) {
      this.PageStatusModel = JSON.parse(localStorage.getItem("PageStatus"));
    }
    this.PageStatusModel.View = view;
    localStorage.setItem("PageStatus", JSON.stringify(this.PageStatusModel));
    this.view = view;
    this.searchCriteria.IsSearchButtonClicked = false;
    this._propertyListingService.currentView = view;
    this.searchCriteria.IsTabClicked = true;
    if (view == View.Map) {
      this.searchCriteria.IsMapView = true;

    }
    else {
      this.Shared.highlightPropertyCard(0);
      this.searchCriteria.IsMapView = false;
      this.propertySearchCriteria(this.searchCriteria);
    }
    if (this.searchCriteria.PropertyFor == this.propertyFor.Exchange1031) {
      this.current1031view = view;
      localStorage.setItem("1031Tab", JSON.stringify(this.current1031view));
      localStorage.setItem("ListingTab", JSON.stringify(this.currentListingview));
    }
    else {

      this.currentListingview = view;
      localStorage.setItem("ListingTab", JSON.stringify(this.currentListingview));
      localStorage.setItem("1031Tab", JSON.stringify(this.current1031view));

    }
  }

  onSortClick(value: Sort) {

    switch (value) {
      case Sort.PriceHighLow:
        this.sortOption = '(Price High to Low)';
        break;
      case Sort.PriceLowHigh:
        this.sortOption = '(Price Low to High)';
        break;
      case Sort.TenantAtoZ:
        this.sortOption = '(A-Z)';
        break;
      case Sort.TenantZtoA:
        this.sortOption = '(Z-A)';
        break;
      default:
        this.sortOption = '(Price High to Low)';
        break;
    }

    this.loaderService.display(true);
    this.searchCriteria.SortValue = value;
    this.searchCriteria.IsSearchButtonClicked = false;
    this.searchCriteria.Brokerages = [];
    this.changeSortLabel = false;
    this.propertySearchCriteria(this.searchCriteria);
    this.loaderService.display(false);
  }

  checknetLeaseTabAcees() {
    if (!this.authService.Admin() && !this.authService.SuperAdmin() && !this.authService.Broker()) {
      this.loaderService.display(true);
      this._userService.Get1031AccessStatus(this.user.Id).subscribe(response => {
        this.accessTo1031Id = Number(response);
        this.loaderService.display(false);
        if ((this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.authService.IsUserRole(this.authService.UserRole.Principal)) && ((this.Is1031EnabledId == null || this.accessTo1031Id != Access1031.Has1031Access) || (this.authService.Principal() && this.Is1031EnabledId == YesNo.Yes))) {
          //this._toastService.addToast({ title: 'Unauthorized Action', msg: 'Your request to view 1031 properties is pending approval. Our broker will get in touch with you shortly', timeout: 3000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
          this.check1031InquiryStatusForNetLease(PropertyFor.Exchange1031);
        }
        else {
          this.showIs1031Tab = false;
        }
      });
    }
    else {
      this.showIs1031Tab = false;
    }
  }

  changeSortLabel = true;

  prevView = View.Grid;
  showAccessTo1031Listings = false;
  onPropertyTypeTabClick(value: PropertyFor) {
    this.propertyCount = 0;
    if (!this.authService.Admin() && !this.authService.SuperAdmin() && !this.authService.Broker() && value == PropertyFor.Exchange1031) {
      this.loaderService.display(true);
      this._userService.Get1031AccessStatus(this.user.Id).subscribe(response => {
        this.accessTo1031Id = Number(response);
        this.loaderService.display(false);
        if ((this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.authService.IsUserRole(this.authService.UserRole.Principal)) && value == PropertyFor.Exchange1031 && ((this.Is1031EnabledId == null || this.accessTo1031Id != Access1031.Has1031Access) || (this.authService.Principal() && this.Is1031EnabledId == YesNo.Yes))) {
          //this._toastService.addToast({ title: 'Unauthorized Action', msg: 'Your request to view 1031 properties is pending approval. Our broker will get in touch with you shortly', timeout: 3000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
          this.check1031InquiryStatus(value);
        }
        else {
          this.showAccessTo1031Listings = false;
          if (value == PropertyFor.Exchange1031 && this.authService.IsUserRole(this.authService.UserRole.Principal1031)) {
            this._propertyListingService.showDisLike = true;
          }
          if (value == PropertyFor.Exchange1031) {
            //this.prevView = this.view;
            this.view = this.current1031view;
            localStorage.setItem("1031Tab", JSON.stringify(this.view));
            localStorage.setItem("ListingTab", JSON.stringify(this.currentListingview));
          }
          else {
            if (value == this.propertyFor.Sale) {
              this.view = this.currentListingview;
              localStorage.setItem("ListingTab", JSON.stringify(this.view));
              localStorage.setItem("1031Tab", JSON.stringify(this.current1031view));

            }
            //this.view = this.prevView;
          }
          this.loaderService.display(true);
          this.activePropertyTab = value;
          this._propertyListingService.activePropertyTab = this.activePropertyTab;
          this.searchCriteria.IsSearchButtonClicked = false;
          this.searchCriteria.PropertyFor = value;
          this.searchCriteria.IsTabClicked = true;
          if (this.view == 3) {
            this.searchCriteria.IsTileList = false;
          }
          {
            this.searchCriteria.IsTileList = true;
          }
          this.searchCriteria.Brokerages = [];
          this.propertySearchCriteria(this.searchCriteria);
          this.loaderService.display(false);
          this.Shared.highlightPropertyCard(0);
        }
      });
    }
    else {
      this.showAccessTo1031Listings = false;
      if (value == PropertyFor.Sale) {
        this._propertyListingService.showDisLike = false;
      }
      else if (value == PropertyFor.Exchange1031 && this.authService.IsUserRole(this.authService.UserRole.Principal1031)) {
        this._propertyListingService.showDisLike = true;
      }
      if (value == PropertyFor.Exchange1031) {
        //this.prevView = this.view;
        this.view = this.current1031view;
        localStorage.setItem("1031Tab", JSON.stringify(this.view));
        localStorage.setItem("ListingTab", JSON.stringify(this.currentListingview));
      }
      else {
        if (value == this.propertyFor.Sale) {
          this.view = this.currentListingview;
          localStorage.setItem("ListingTab", JSON.stringify(this.view));
          localStorage.setItem("1031Tab", JSON.stringify(this.current1031view));

        }
        //this.view = this.prevView;
      }
      this.loaderService.display(true);
      this.activePropertyTab = value;
      this._propertyListingService.activePropertyTab = this.activePropertyTab;
      this.searchCriteria.IsSearchButtonClicked = false;
      this.searchCriteria.PropertyFor = value;
      if (this.view == 3) {
        this.searchCriteria.IsTileList = false;
      }
      {
        this.searchCriteria.IsTileList = true;
      }
      this.searchCriteria.Brokerages = [];
      this.propertySearchCriteria(this.searchCriteria);
      this.loaderService.display(false);
      this.Shared.highlightPropertyCard(0);
    }
    this.PageStatusModel.View = this.view;
    localStorage.setItem("PageStatus", JSON.stringify(this.PageStatusModel));
  }



  /**
   * Overriden the base class method
   * @param searchParameters 
   */
  propertySearchCriteria(searchParameters: IPropertySearchCriteria) {
    this.Shared.FilterClicked(true);
    if (this.changeSortLabel) {
      this.sortOption = '(Price High to Low)';
    }
    this.changeSortLabel = true;
    this.currentPoint = 0;
    this.searchCriteria = searchParameters;
    if ((this.searchCriteria.StateId != null && this.searchCriteria.StateId != undefined) && typeof this.searchCriteria.StateId === 'number') {
      this.filterStateId = this.searchCriteria.StateId;
    }
    //} else if ((this.searchCriteria.StateId != null && this.searchCriteria.StateId != undefined) && typeof this.searchCriteria.StateId === 'object') {
    //  this.filterStateId = this.searchCriteria.StateId?.[0];
    //}
    this.searchCriteria.PropertyFor = this.activePropertyTab;
    if (this.search !== undefined) {
      this.subscription.add(this._propertyListingService.getUserSavedSearchCriteria(this.search).subscribe((response: IPropertySearchCriteria) => {
        this.searchCriteria = response;
        this.searchCriteria.PropertyFor = this.activePropertyTab;
      }));
    }

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.searchCriteria.IsFavorite = params['isFav'] != undefined ? true : this.searchCriteria.IsFavorite ? true : false;
      this.searchCriteria.IsDisliked = params['isDisliked'] != undefined ? true : this.searchCriteria.IsDisliked ? true : false;
    });

    const searchCriteria: IPropertySearchCriteria = {
      Address: this.searchCriteria.Address,
      AssetTypes: this.searchCriteria.AssetTypes,
      Ratings: this.searchCriteria.Ratings,
      PriceFrom: this.searchCriteria.PriceFrom,
      PriceTo: this.searchCriteria.PriceTo,
      SkipCount: this.currentPoint,
      SortValue: this.searchCriteria.SortValue,
      TakeCount: this._takeCount,
      Tenants: this.searchCriteria.Tenants,
      Terms: this.searchCriteria.Terms,
      IsMapView: this.searchCriteria.IsMapView,
      Guid: this.searchCriteria.Guid,
      NOIFrom: this.searchCriteria.NOIFrom,
      NOITo: this.searchCriteria.NOITo,
      BuildingSizeFrom: this.searchCriteria.BuildingSizeFrom,
      BuildingSizeTo: this.searchCriteria.BuildingSizeTo,
      YearBuiltFrom: this.searchCriteria.YearBuiltFrom,
      YearBuiltTo: this.searchCriteria.YearBuiltTo,
      StateId: this.filterStateId,
      LeaseStructures: this.searchCriteria.LeaseStructures,
      CapRateFrom: this.searchCriteria.CapRateFrom,
      CapRateTo: this.searchCriteria.CapRateTo,
      PropertyStatus: this.searchCriteria.PropertyStatus,
      SubCategories: this.searchCriteria.SubCategories,
      IsRentAmount: this.searchCriteria.IsRentAmount,
      RentFrom: this.searchCriteria.RentFrom,
      RentTo: this.searchCriteria.RentTo,
      OwnershipTypes: this.searchCriteria.OwnershipTypes,
      IsExcludeSoldListing: this.searchCriteria.IsExcludeSoldListing,
      IsOnlySoldListing: this.searchCriteria.IsOnlySoldListing,
      IsExcludeContractListing: this.searchCriteria.IsExcludeContractListing,
      IsOnlyFeaturedListing: this.searchCriteria.IsOnlyFeaturedListing,
      LoggedInUserId: this.searchCriteria.LoggedInUserId,
      IsFavorite: this.searchCriteria.IsFavorite,
      PropertyFor: this.searchCriteria.PropertyFor,
      IsComp: this.searchCriteria.IsComp,
      IsArchive: this.searchCriteria.IsArchive,
      IsDisliked: this.searchCriteria.IsDisliked,
      IsTileList: this.searchCriteria.IsTileList,
      IsSearchButtonClicked: this.searchCriteria.IsSearchButtonClicked,
      MinTerm: this.searchCriteria.MinTerm,
      MaxTerm: this.searchCriteria.MaxTerm,
      Brokerages: this.searchCriteria.Brokerages,
      States: this.searchCriteria.States,
      AddressTypeId: this.searchCriteria.AddressTypeId,
      AddressType: this.searchCriteria.AddressType,
      AddressTypeName: this.searchCriteria.AddressTypeName,
      CharacteristicsId: this.searchCriteria.CharacteristicsId,
      IsPortfolio: this.searchCriteria.IsPortfolio,
      PropertySequenceId: this.searchCriteria.PropertySequenceId,
      TenantAddress: this.searchCriteria.TenantAddress,
      CityId: this.searchCriteria.CityId,
      IsSavedSearch: this.searchCriteria.IsSavedSearch,
      IsReset: this.searchCriteria.IsReset,
      FilterTagCount: this.searchCriteria.FilterTagCount,
      IsTabClicked: this.searchCriteria.IsTabClicked
    };
    this.filterStateId = null;

    if (this.propertyTableView) {
      this.propertyTableView.filter(searchParameters);
    }

    if (this.propertyMapListView) {

      this.propertyMapListView.filter(searchParameters);
    }
    searchCriteria.Brokerages = [];
    this.propertyCardView = this.view === 1 ? true : false;
    super.propertySearchCriteria(searchCriteria);

  }

  private feedNext(takeCount: number) {
    this.currentPoint += takeCount;
    const searchCriteria: IPropertySearchCriteria = {
      Address: this.searchCriteria.Address,
      AssetTypes: this.searchCriteria.AssetTypes,
      Ratings: this.searchCriteria.Ratings,
      PriceFrom: this.searchCriteria.PriceFrom,
      PriceTo: this.searchCriteria.PriceTo,
      SkipCount: this.currentPoint,
      SortValue: this.searchCriteria.SortValue,
      TakeCount: takeCount,
      Tenants: this.searchCriteria.Tenants,
      Terms: this.searchCriteria.Terms,
      IsMapView: false,
      Guid: this.searchCriteria.Guid,
      NOIFrom: this.searchCriteria.NOIFrom,
      NOITo: this.searchCriteria.NOITo,
      BuildingSizeFrom: this.searchCriteria.BuildingSizeFrom,
      BuildingSizeTo: this.searchCriteria.BuildingSizeTo,
      YearBuiltFrom: this.searchCriteria.YearBuiltFrom,
      YearBuiltTo: this.searchCriteria.YearBuiltTo,
      StateId: (this.searchCriteria.StateId != null && this.searchCriteria.StateId != undefined) ? this.searchCriteria.StateId : null,
      LeaseStructures: this.searchCriteria.LeaseStructures,
      CapRateFrom: this.searchCriteria.CapRateFrom,
      CapRateTo: this.searchCriteria.CapRateTo,
      PropertyStatus: this.searchCriteria.PropertyStatus,
      SubCategories: this.searchCriteria.SubCategories,
      IsRentAmount: this.searchCriteria.IsRentAmount,
      RentFrom: this.searchCriteria.RentFrom,
      RentTo: this.searchCriteria.RentTo,
      OwnershipTypes: this.searchCriteria.OwnershipTypes,
      IsExcludeSoldListing: this.searchCriteria.IsExcludeSoldListing,
      IsOnlySoldListing: this.searchCriteria.IsOnlySoldListing,
      IsExcludeContractListing: this.searchCriteria.IsExcludeContractListing,
      IsOnlyFeaturedListing: this.searchCriteria.IsOnlyFeaturedListing,
      LoggedInUserId: this.searchCriteria.LoggedInUserId,
      IsFavorite: this.searchCriteria.IsFavorite,
      PropertyFor: this.searchCriteria.PropertyFor,
      IsComp: true,
      IsArchive: false,
      IsDisliked: this.searchCriteria.IsDisliked,
      IsTileList: true,
      IsSearchButtonClicked: false,
      MinTerm: this.searchCriteria.MinTerm,
      MaxTerm: this.searchCriteria.MaxTerm,
      Brokerages: this.searchCriteria.Brokerages,
      States: this.searchCriteria.States,
      AddressTypeId: this.searchCriteria.AddressTypeId,
      AddressType: this.searchCriteria.AddressType,
      AddressTypeName: this.searchCriteria.AddressTypeName,
      CharacteristicsId: this.searchCriteria.CharacteristicsId,
      IsPortfolio: this.searchCriteria.IsPortfolio,
      PropertySequenceId: this.searchCriteria.PropertySequenceId
    };

    searchCriteria.Brokerages = [];
    super.searchWithCriteria(searchCriteria);
  }

  onScroll($event: any) {


    // this.loaderService.display(true);
    const st = document.documentElement.scrollTop;
    //const st = window.scrollY;

    if (st > this.lastScroll) {
      //const sbHeight = window.innerHeight * (window.innerHeight / document.body.offsetHeight);
      //const scP = ((st + sbHeight) / document.documentElement.scrollHeight) * 100;
      //if (scP > 90 && scP < 100) {
      if ((window.scrollY + document.documentElement.clientHeight >= (document.documentElement.scrollHeight - 350)) && this.enableScrollFn == true) {

        this.loaderService.display(true);
        this.enableScrollFn = false;
        this.feedNext(this._takeCount);
      }
    }

    this.lastScroll = st;
    //this.loaderService.display(false);
  }


  //toaster
  addToast(options: any) {
    if (options.type == "success") {
      this.toastyService.success(options.msg, options.title, {
        timeOut: options.timeout,
        closeButton: true,
      });
    }
    else if (options.type == "error") {
      this.toastyService.error(options.msg, options.title, {
        timeOut: options.timeout,
        closeButton: true,
      });
    }
    else if (options.type == "warning") {
      this.toastyService.warning(options.msg, options.title, {
        timeOut: options.timeout,
        closeButton: true,
      });
    }
  }
  showRequestLink = false;
  showRequestUnderProcessing = false;
  showEBRA = false;
  showEBRASigned = false;
  private check1031InquiryStatus(value: PropertyFor) {
    this.searchCriteria.PropertyFor = value;
    this.showAccessTo1031Listings = true;
    this.showRequestLink = false;
    this.showRequestUnderProcessing = false;
    this.showEBRA = false;
    this.showEBRASigned = false;
    if (this.accessTo1031Id == Access1031.NotSent1031Request) {
      this.showRequestLink = true;
    }
    else if (this.accessTo1031Id == Access1031.Sent1031Request) {
      this.showRequestUnderProcessing = true;
    }
    else if (this.accessTo1031Id == Access1031.EBRALinkSent) {
      this.showEBRA = true;
    }
    else if (this.accessTo1031Id == Access1031.EBRAaccepted) {
      this.showEBRASigned = true;
    }
    else if (this.accessTo1031Id == Access1031.Has1031Access && this.authService.Principal()) {
      this.showEBRASigned = true;
    }
    else if (this.accessTo1031Id == Access1031.Has1031Access) {
      this.showAccessTo1031Listings = false;
      if (this.signEBRA && this.router.url.indexOf('signEBRA=true') > -1) {
        this.Validation.navigateByUrl('/propertylisting?request=buy');
      }
    }
  }

  private check1031InquiryStatusForNetLease(value: PropertyFor) {
    this.showIs1031Tab = true;
    if (this.accessTo1031Id == Access1031.Has1031Access) {
      this.showIs1031Tab = false;
      
    }
  }

  on1031InquiryRequest() {
    this.loaderService.display(true);
    this.subscription.add(this._userService.Save1031Inquiry(this.user.Id).subscribe(response => {
      if (response) {
        this.accessTo1031Id = Access1031.Sent1031Request;
        this.showRequestLink = false;
        this.showRequestUnderProcessing = true;
        this._toastService.addToast({ title: 'Success', msg: 'Your 1031 access request is saved successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
      }
      else {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Your 1031 access request is failed to save.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
      this.loaderService.display(false);
    }));
  }

  isAgreed = false;
  onBRAAccept() {
    this.loaderService.display(true);
    this.subscription.add(this._userService.GenerateBRA(this.user.Id).subscribe(res => {
      if (res) {
        this.accessTo1031Id = Access1031.EBRAaccepted;
        this.showEBRA = false;
        this.showEBRASigned = true;
        this.modalRefTC.hide();
        this.Validation.scrollTop();
        this._toastService.addToast({
          title: 'Success', msg: '1031 Trade Participation Agreement signed successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
        })
      }
      else {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Failed to sign 1031 Trade Participation Agreement', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
      this.loaderService.display(false);
    }));
  }

  @ViewChild('AcceptTC') AcceptTC: TemplateRef<null>;
  modalRefTC: BsModalRef;
  confirmEBRAAccept() {
    this.modalRefTC = this.modalService.show(this.AcceptTC);
  }

  openLoginModal(template: TemplateRef<any>, classes: any) {
    if (this.authService.isAuth0Enabled) {
      this._auth0.login();
    }
    else {
      this.modalRefLogin = this.modalService.show(template, { class: classes });
    }
  };

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  clearSearch() {
    this.searchCriteria = {} as IPropertySearchCriteria;
    this.defaultSearchCriteriaValues();
    this.searchCriteria.IsFavorite = false;
    this.searchCriteria.IsDisliked = false;
    this.isPropertySaleTabHidden = true;
    this.activePropertyTab = 601;
    this.searchCriteria.PropertyFor = this.activePropertyTab;
    this._propertyListingService.showDisLike = false;
    this.propertySearchCriteria(this.searchCriteria);
  }

  onFilterSearchClick(value: FilterSearch) {
    if (value == FilterSearch.Dislike) {
      this.defaultSearchCriteriaValues();
      this.child.clearSearchFromListing();
      this.searchCriteria.IsDisliked = true;
      this.searchCriteria.IsFavorite = false;
      this._propertyListingService.showDisLike = true;
      this.propertySearchCriteria(this.searchCriteria);
      //this.searchCriteria.IsDisliked = false;
      //this._propertyListingService.showDisLike = false;
      this.currentFilter = FilterSearch.Dislike;

    }
    else if (value == FilterSearch.Favorites) {
      this.defaultSearchCriteriaValues();
      this.child.clearSearchFromListing();
      this.searchCriteria.IsFavorite = true;
      this.searchCriteria.IsDisliked = false;
      this._propertyListingService.showDisLike = false;
      this.propertySearchCriteria(this.searchCriteria);
      this.currentFilter = FilterSearch.Favorites;
    //  this.searchCriteria.IsFavorite = false;
    }
  }

  savedSearchOutputModelList: ISavedSearchOutputModel[];
  canShowSaveSearchText = false;
  getSavedSearches() {
    this._propertyListingService.getUsersavedSearch(this.user.Id).subscribe((response: ISavedSearchOutputModel[]) => {
      this.savedSearchOutputModelList = response;
      if (this.savedSearchOutputModelList.length > 0 && this.canShowsavedSearch == true) {
        this.canShowSaveSearchText = false;
      }
      else {
        this.canShowSaveSearchText = true;
      }
    });
  }

  setSearch(searchValue) {
    this.child.clearSearchFromListing();
    this.child.setBuildTags(searchValue);
    this.currentFilter = FilterSearch.SaveSearch;
  }
  reloadSaveSearch() {
    this.getSavedSearches();
  }

  onSaveSearch() {
    this.child.openSaveSearchModal();
  }


  getTotalCount() {
    let buyCount = this.propertyTabCount != null && this.propertyTabCount != undefined ? this.propertyTabCount : 0;
    if (this.canShow1031Properties && !this.showAccessTo1031Listings) {
      let netleaseCount = this.propertyCount != null  && this.propertyCount != undefined ? this.propertyCount : 0;
      return buyCount + netleaseCount;
    }
    else {
      return buyCount;
    }
  }


  showMenu() {
    if ((this.canShowsavedSearch || this.authService.Broker()) && this.savedSearchOutputModelList?.length > 0) {
      return true;
    }
    else if (this.authService.Principal1031() || this.authService.Principal() || this.authService.ExternalBroker()) {
      return true;
    }
    else {
      return false;
    }
  }
}
